import React from 'react';
import { Container } from 'reactstrap';
import SimpleHeader from 'components/Headers/SimpleHeader';
import BookListComponent from './BookListComponent';

export default function Books() {
  return (
    <React.Fragment>
      <SimpleHeader name='Sách điện tử' parentName='Sách số' />
      <Container className='mt--6' fluid>
        <BookListComponent />
      </Container>
    </React.Fragment>
  );
}
